import { render } from "./ProgramsView.vue?vue&type=template&id=5b2c6be5&scoped=true"
const script = {}

import "./ProgramsView.vue?vue&type=style&index=0&id=5b2c6be5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2c6be5"]])

export default __exports__